@if (showLight) {
  <img  [class]="class" [src]="getAsset(rating)" [alt]="getAlt(rating) | translate">
}
